<template>
  <section>
    <b-alert
      variant="primary"
      show
    >
      <h4 class="alert-heading">
        Nota
      </h4>

      <div class="alert-body">
        <span>
          No olvide que el archivo debe estar en formato <strong>CSV</strong>, separado por comas y con los marcadores correctos.
        </span>
      </div>
    </b-alert>

    <b-form-file
      v-model="file"
      placeholder="Selecciona tu archivo o arrastra y suelta aquí..."
      drop-placeholder="Suelta tu archivo aquí..."
      accept=".csv"
    />
  </section>
</template>

<script>
import {
  BAlert,
  BFormFile,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { watch } from '@vue/composition-api'
import { useMassiveRegister } from '../useMassiveRegister'

export default {
  components: {
    BFormFile,
    BAlert,
  },
  directives: {
    Ripple,
  },
  setup(_, { emit }) {
    const { file, parseCSV } = useMassiveRegister()

    watch(file, newFile => {
      if (!newFile) return

      const reader = new FileReader()

      reader.onload = e => {
        const csvText = e.target.result
        const result = parseCSV(csvText)

        emit('input', result)
      }

      reader.readAsText(newFile, 'ISO-8859-1')
    })

    return {
      file,
    }
  },
}
</script>
